<template>
  <v-col class="mx-4">
    <Details />
  </v-col>
</template>
<script>
import Details from "@/components/front/tracking/Details.vue";
export default {
  components: {
    Details,
  },
};
</script>
